export default {
    name: 'AppHeader',    
    created() {
        this.CheckLoginStatus();
        setInterval(() => this.GetInbox(), 1000);
      //  setInterval(() => this.GetNotification(), 1000);
  


    },
    data() {
        return {  
            loginDetails: null,
            Info: [],
            TempInfo: [],
            Notifications: [],
            NotificationCount: 0,
            CalendarCount:0,
            Calendar:[],
            Count: 0,
        };
    },
  
    methods: {
        Logout() {
            window.location.href = "/Login";
        },

        CheckLoginStatus() {
            try {
                this.loginDetails = JSON.parse(localStorage.getItem('currentUser-client'));
                if (this.loginDetails == null) {
                    window.location.href = '/Login';
                }
            } catch (error) {
                window.location.href = '/Login';
            }
        },
        href(url) {
            this.$router.push(url);
        },
        GetInbox() {
            this.$http.GetInbox(this.loginDetails.sender_type)
                .then(response => {
                    //debugger
                    if (this.Count != response.data.count) {
                        this.playSound();
                    }
                    this.Info = response.data.info;
                    this.TempInfo = response.data.info;
                    this.Count = response.data.count;
                })
                .catch(() => {
                });

        },


        GetNotification() {
            this.$http.GetNotification(2)
                .then(response => {
                    this.Notifications = response.data.notifications;
                    this.NotificationCount = response.data.count;
                })
                .catch(() => {
                });
        },


        GetCalendar() {
            this.$http.GetCalendar(this.loginDetails.trainingFoundationId)
                .then(response => {
                    this.Calendar = response.data.calendar;
                    this.CalendarCount = response.data.count;
                })
                .catch(() => {
                });
        },


        playSound() {
            const audio = new Audio("windows8_email_notif.mp3");
            audio.play();
        }
    }    
}
